const elements = {
  triggers: document.querySelectorAll('.js-person-trigger')
}

const active = 'is-active';

function init() {
  if (elements.triggers.length > 0) {
    elements.triggers.forEach((trigger) => trigger.addEventListener('click', () => {
      const container = trigger.parentNode.closest('.js-person');
      const content = container ? container.querySelector('.js-content') : null;

      if (container && content) {
        if (!container.classList.contains(active)) {
          content.style.maxHeight = `${content.scrollHeight}px`;
        } else {
          content.style.maxHeight = 0;
        }
        container.classList.toggle(active);
      }
    }));
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/turnbull/person/person.js